import { useTranslation } from "react-i18next";
import { useGetSalonQuery, useUpdateSalonMutation } from "../redux/salonApi";
import { SaveSalonPropsInterface } from "../redux/salonTypes";
import React, { useEffect, useMemo } from "react";
import { Col, Row } from "react-bootstrap";
import { SalonForm } from "./parts/form";
import { toast } from "react-toastify";
import { useNavigate, useParams } from "react-router-dom";
import { useBreadcrumbs } from "../../../app/hooks";

export const SalonEdit = () => {
  const { id } = useParams<{ id: string }>();
  const { t } = useTranslation();
  const [updateSalon, { isSuccess, isError, error }] = useUpdateSalonMutation();
  const { data: salonData, isLoading } = useGetSalonQuery(id!);
  const navigate = useNavigate();

  const breadcrumbs = useMemo(
    () => [
      {
        url: "/panel/salons",
        label: "menu.salon_list",
      },
      {
        url: `/panel/salons/${id}/edit`,
        label: "menu.edit_salon",
      },
    ],
    [id]
  );

  useBreadcrumbs(breadcrumbs);

  const onSubmit = (data: SaveSalonPropsInterface) => {
    updateSalon({
      id: id!,
      ...data,
    });
  };

  useEffect(() => {
    if (isSuccess) {
      toast.success(t("salon_edited_successfully"));
      navigate("/panel/salons");
    }
  }, [isSuccess]);

  return (
    <React.Fragment>
      <Row>
        <Col>
          <div className="iq-card">
            <div className="iq-card-header d-flex justify-content-between">
              <div className="iq-header-title">
                <h4 className="card-title">{t("edit_salon")}</h4>
              </div>
            </div>
            <div className="iq-card-body">
              <SalonForm
                isError={isError}
                data={salonData}
                error={error}
                onSubmit={onSubmit}
              />
            </div>
          </div>
        </Col>
      </Row>
    </React.Fragment>
  );
};
